import React, { useContext, useMemo } from 'react';

const LabelsContext = React.createContext<Labels>({});

export function useLabels() {
    return useContext(LabelsContext);
}

interface LabelsProviderProps {
    children: React.ReactNode;
    labels: Labels | null;
    prefix?: string;
}

export function LabelsProvider({ children, labels, prefix = null }: LabelsProviderProps) {
    const previousLabels = useLabels();
    const finalLabels = useMemo(
        () => ({
            ...previousLabels,
            ...Object.keys(labels || {}).reduce(
                (acc, key) => ({
                    ...acc,
                    [prefix !== null
                        ? `${prefix}${key.substring(0, 1).toUpperCase()}${key.substring(1)}`
                        : key]: labels[key],
                }),
                {},
            ),
        }),
        [previousLabels, labels, prefix],
    );
    return <LabelsContext.Provider value={finalLabels}>{children}</LabelsContext.Provider>;
}

export default LabelsContext;
